import React from 'react';
import ContentLoader from 'react-content-loader'




const CarDetailsLoader = (props) => {
	if (window.isMobile() == 'desktop') {
		return (
			<ContentLoader preserveAspectRatio="none" >
				<rect x="50" y="0" width="100" height="20"></rect>
				<rect x="155" y="0" width="100" height="20"></rect>
				<rect x="260" y="0" width="100" height="20"></rect>
				<rect x="65" y="30" width="280" height="10"></rect>
				<rect x="65" y="45" width="280" height="10"></rect>
				<rect x="65" y="60" width="280" height="10"></rect>
				<rect x="65" y="75" width="280" height="5"></rect>
				<rect x="30%" y="85" width="150" height="5"></rect>
			</ContentLoader>

		)
	} else {
		return (
			<ContentLoader preserveAspectRatio="none" height="150" >
				<rect x="50" y="0" width="70%" height="40"></rect>
				<rect x="50" y="50" width="70%" height="40"></rect>
				<rect x="50" y="100" width="70%" height="40"></rect>

			</ContentLoader>

		)
	}
}

export default CarDetailsLoader;